export enum EComparisonType {
    EQUALS = 'EQUALS',
    GREATER = 'GREATER',
    LESS = 'LESS',
    GREATER_OR_EQUAL = 'GREATER_OR_EQUAL',
    LESS_OR_EQUAL = 'LESS_OR_EQUAL'

}
export const FORM_WATCHER_EVENT = 'form-changed';
